import React, { useEffect, useState } from 'react'

import { getChallengeResponsesForChallenge } from '@src/pages/workflow/settings/analytics.resource'
import { toastService } from '@utils/toast.service'
import { WorkflowLeaderboard } from '@src/pages/workflow/settings/challenge-items/workflow-leaderboard.component'

type WorkflowLeaderboardItemPercentageProps = {
  workflowChallenge: WorkflowChallenge
  isAdmin: boolean
  onEdit: (challenge: WorkflowChallenge) => void
  onDelete: (id: string) => void
  participantsCount: number
}

export function WorkflowLeaderboardItemPercentage({
  workflowChallenge,
  isAdmin,
  onEdit,
  onDelete,
  participantsCount,
}: WorkflowLeaderboardItemPercentageProps) {
  const [responses, setResponses] = useState<any[]>([])

  useEffect(() => {
    getChallengeResponsesForChallenge(workflowChallenge as any)
      .then(setResponses)
      .catch(err => {
        console.log(err)
        toastService.error(
          'There was an error retrieving challenge data. Please try again later.',
        )
      })
  }, [])

  return (
    <WorkflowLeaderboard
      workflowChallenge={workflowChallenge}
      responses={responses}
      displayGoal={(goal: string) => `${goal}%`}
      displayValue={({ value }: { value: number }) => `${value}%`}
    >
      <WorkflowLeaderboard.Header
        canEdit={isAdmin}
        onEdit={onEdit}
        onDelete={onDelete}
        participantsCount={participantsCount}
      />
      <WorkflowLeaderboard.Body />
    </WorkflowLeaderboard>
  )
}
